"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _default = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var index = _ref.index,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["index", "className"]);
  var classes = 'skeleton bg-secondary';
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])('flex items-center py-5', className)
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-12 h-12 rounded-full ml-12 mr-5')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col min-w-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'mr-2 w-20 h-4')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-20 h-4')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'mr-2 w-40 h-4')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-40 h-4')
  })))));
});

exports["default"] = _default;
//# sourceMappingURL=ThreadListItem.js.map